import { useQuery } from "react-query";
import { GetTimeseriesRequest } from "../types/timeseries";
import { getIpcScoreFeatureAndGroup } from "../services/ipcScore";
import useQueryState from "./useQueryState";
import useCountries from "./useCountries";

export type UseTimeseries = GetTimeseriesRequest;

const useIPCScore = () => {
  const {
    queryState: { ipcScore, country, aggregationLevel, geographicalUnit },
  } = useQueryState();
  const {
    getCountryAdministrativeUnit: { data: geoUnit, isLoading },
  } = useCountries({ country, aggregationLevel });
  const selectedGeoUnit = geoUnit?.features.find(
    (area) => area.properties?.location_id === geographicalUnit,
  );

  const isSystemType =
    aggregationLevel === "0" ||
    aggregationLevel === "1" ||
    aggregationLevel === "2";

  const type = isSystemType ? "system" : "user";

  const ipcScoreResponse = useQuery(
    ["ipcScore", country, aggregationLevel, geographicalUnit, type],
    async () =>
      await getIpcScoreFeatureAndGroup({
        country,
        aggregationLevel,
        geographicalUnit: selectedGeoUnit?.properties?.geounit ?? "",
        type,
      }),
    {
      retry: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled: ipcScore && !isLoading && !!selectedGeoUnit?.properties?.geounit,
    },
  );

  return ipcScoreResponse;
};

export default useIPCScore;
